import { createRoute, redirect } from '@tanstack/react-router'
import { store } from 'store/store'

import { OrderCreateRoute } from '../pages'
import { orderRoute } from './OrderRoute'

export const orderCreateRoute = createRoute({
  beforeLoad: async (options) => {
    const { token } = store.getState().authReducer
    if (!token) {
      throw redirect({
        to: '/order-guest/create',
        search: {
          data: options.search.data
        }
      })
    }
  },
  getParentRoute: () => orderRoute,
  component: () => <OrderCreateRoute />,
  path: '/create'
})
